const SectionTestimonials = Class(
	/**
	 * @lends {SectionTestimonials#}
	 */
	{
		bodyClass: 'small-nav',
		menuItem: 'testimonials',

		_MENU: ['event', 'local', 'corporate', 'online'],

		__construct: function () {
			this.node = mkE({
				tag: 'div',
				id: 'testimonials'
			});
		},

		draw: function () {
			let menuItems = [];
			let type = this.url.shift();
			let selected = null;

			for( let i = 0; i < this._MENU.length; i++ ) {
				let key = this._MENU[i];
				if( key === type ) {
					selected = key;
				}
				if(this._getQuotes(key).length === 0) {
					continue;
				}
				menuItems.push({
					name: key,
					url: D.url(`/testimonials/${key}/`),
					caption: D.Lang.get(`testimonials.section.menu.${key}`)
				});
			}

			if( selected === null ) {
				selected = menuItems[0].name;
			}

			mkE({
				tag: 'header',
				els: [
					{
						tag: 'div',
						className: 'container',
						els: [
							{
								tag: 'h1',
								text: D.Lang.get('testimonials.section.header')
							},
							this._tabs = new T.MainTabs({
								items: menuItems,
								active: selected
							})
						]
					}
				]
			}).append(this.node);

			this._content = mkE({
				tag: 'div',
				className: 'container content'
			}).append(this.node);

			this.drawTab(selected);

			this.node.append(this.layout.ct());

			this.ready();
		},

		/**
		 * @param {string} type
		 * @returns {Array}
		 * @private
		 */
		_getQuotes: function ( type ) {
			return D.QUOTES.filter(quote => {
				return quote.type === type && (quote.languages.length === 0 || quote.languages.includes(D.LANG))
			}) || [];
		},

		drawTab: function ( type ) {
			clearNode(this._content);
			let quotes = this._getQuotes(type);
			if( type === 'corporate' ) {
				quotes = quotes.concat(this._getQuotes('business'));
			}
			if( !quotes.length ) {
				return null;
			}
			for( let i = 0; i < quotes.length; i++ ) {
				this.drawItem(quotes[i]);
			}
		},

		drawItem: function ( data ) {
			let url = null;
			const event_id = D.Lang.get(`testimonials.${data.id}.event_id`) || null;
			if(event_id > 0) {
				url = D.url(`/event/${event_id}`);
			}
			mkE({
				tag: 'article',
				id: `testimonial-${data.id}`,
				className: 'testimonial',
				els: [
					{
						tag: 'div',
						className: 'header',
						els: [
							{
								tag: 'img',
								className: 'image',
								src: data.image
							},
							{
								tag: 'h4',
								className: 'person',
								text: D.Lang.get(`testimonials.${data.id}.name`)
							},
							{
								tag: 'div',
								className: 'position',
								text: D.Lang.get(`testimonials.${data.id}.position`)
							}
						]
					},
					{
						tag: 'div',
						className: 'text',
						text: D.Lang.get(`testimonials.${data.id}.full_text`)
					}
				]
			}).append(this._content);
		},

		onShow: function () {
			const id = this.url.get.v('id') || null;
			if( id === null ) {
				return;
			}
			D.scrollIntoView(document.getElementById(`testimonial-${id}`));
		}

	},
	Section
);
